class SizeGuide extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handlePanelTab = this.handlePanelTab.bind(this)
    this.handleUnit = this.handleUnit.bind(this)

    this.listeners.add(
      this.els['panel-select'].element,
      'change',
      this.handlePanelTab,
    )

    this.els['panel-tab']?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handlePanelTab)
    })

    this.els['unit-trigger']?.elements.forEach((unitTriggerEl) => {
      this.listeners.add(unitTriggerEl, 'click', this.handleUnit)
    })

    // Measurements panel
    this.handleMeasurementsTab = this.handleMeasurementsTab.bind(this)

    this.els['measurements-tab']?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleMeasurementsTab)
    })
  }

  handlePanelTab (event) {
    const panelToShow =
      event.type === 'change' ? event.target.value : event.target.dataset.panel

    this.els['panel-tab'].elements.forEach((triggerEl) => {
      triggerEl.setAttribute(
        'aria-pressed',
        triggerEl.dataset.panel === panelToShow,
      )
    })

    this.els.panel.elements.forEach((panelEl) => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.panel !== panelToShow,
      )
    })

    this.els.media?.elements.forEach((mediaEl) => {
      mediaEl.setAttribute(
        'aria-hidden',
        mediaEl.dataset.panel !== panelToShow,
      )
    })

    if (panelToShow === 'fitguide' && this.els.video?.exists) {
      for (const source in this.els.video.element.children) {
        const videoSource = this.els.video.element.children[source]

        if (
          typeof videoSource.tagName === 'string' &&
          videoSource.tagName === 'SOURCE'
        ) {
          if (videoSource.dataset.src) {
            videoSource.src = videoSource.dataset.src

            videoSource.removeAttribute('data-src')

            this.els.video.element.load()
          }
        }
      }
    }
  }

  handleMeasurementsTab (event) {
    this.els['measurements-tab'].elements.forEach((triggerEl) => {
      triggerEl.setAttribute(
        'aria-pressed',
        triggerEl.dataset.type === event.target.dataset.type,
      )
    })

    this.els['measurements-tab-panel'].elements.forEach((panelEl) => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.type !== event.target.dataset.type,
      )
    })
  }

  async handleUnit () {
    const newUnit = this.dataset.unit === 'cm' ? 'in' : 'cm'

    this.setAttribute('data-unit', newUnit)

    await window.BAO.Cart.updateCartAttributes({
      size_guide_unit: newUnit,
    })
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide)
}
